module.exports = __webpack_public_path__ + "static/media/arrow-down-menu.b568e87f.svg";